module.exports = __webpack_public_path__ + "static/media/preview.90cb13f6.png";